module.exports = __webpack_public_path__ + "img/snack.f0a5e56f.png";